/*
 *******************************************************************************
 * 
 *  Filename:   ./reducer.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers take dispatch results and apply them to the state.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 8:52 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      09/17/2018  NJN     Add Components and Component Pages
 *      09/18/2018  NJN     Add Navs
 *      09/25/2018  NJN     Add BlockValidationTypeFields
 *      09/27/2018  NJN     Add BlockElementOptions, BlockElementTypes, BlockGroups
 *      09/30/2018  NJN     Add Blocks, BlockElements
 *      10/28/2018  NJN     Add BlockDatas
 *      11/14/2018  NJN     Add BlockFormats, BlockFormatLevels
 *      11/19/2018  NJN     Add Folders
 *      12/02/2018  NJN     Add FileTypes
 *      12/03/2018  NJN     Add Contacts
 *      01/21/2019  NJN     Add Consequences
 *      01/21/2019  NJN     Add Probabilities
 *      01/21/2019  NJN     Add RiskClasses
 *      01/21/2019  NJN     Add RiskMatrix
 *      01/21/2019  NJN     Add Assets
 *      03/05/2019  NJN     Add Field Set Groups, Field Sets, Fields
 *      04/01/2019  NJN     Add GCSEquipments, Inspections
 *      05/13/2019  NJN     Add Location States, Countries, Counties, Zip Codes
 *      06/15/2019  NJN     Add Projects, Versions
 *      06/27/2019  NJN     Add Project_ProjectJobs
 *      07/06/2019  NJN     Add GoCampaign_PoliticalDistrictGroups, LocationCities
 *      07/10/2019  NJN     Add GoCampaign_PoliticalDistricts
 *      07/11/2019  NJN     Add GoCampaign_OfficeGroups
 *      09/29/2019  NJN     Add GoCampaign_PrecinctGroups, VoterDB_Voters
 *      10/26/2019  NJN     Add GoCampaign_Counties, GoCampaign_Precincts
 *      12/09/2019  NJN     Add ExportTypes, ExportTypeFilters, ExportJobs
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import { reducer as toastr } from 'react-redux-toastr';
import { routerReducer } from 'react-router-redux';

import auth from './reducers/auth';
import register from './reducers/register';
import common from './reducers/common';
import reducerContentListItems from './reducers/reducerContentListItems';
import reducerMedias from './reducers/reducerMedias';
import reducerFolders from './reducers/reducerFolders';
import reducerUsers from './reducers/reducerUsers';
import reducerCompanies from './reducers/reducerCompanies';
import reducerEmailSettings from './reducers/reducerEmailSettings';
import reducerFormMessages from './reducers/reducerFormMessages';

export default combineReducers({
  auth,
  register,
  common,
  form,
  toastr,
  reducerFolders,
  reducerContentListItems,
  reducerMedias,
  reducerCompanies,
  reducerUsers,
  reducerEmailSettings,
  reducerFormMessages,
  router: routerReducer
});